import {AfterViewInit, ChangeDetectorRef, Component, ElementRef, OnInit} from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';
import {AuthenticationService} from '../../services/authentication/authentication.service';
import {Role} from '../../models/roles';
import {
  faCalendar,
  faComment,
  faDownload,
  faEllipsisH,
  faFile, faInbox,
  faListUl,
  faNewspaper,
  faPhoneAlt,
  faShoppingCart,
  faSignOutAlt,
  faSms,
  faTable,
  faUser,
  faUsers
} from '@fortawesome/free-solid-svg-icons';


declare interface RouteInfo {
  path: string;
  title: string;
  icon: any;
  class: string;
}


export const ROUTES: RouteInfo[] = [
  {path: '/user/orders', title: 'سفارش های من', icon: faShoppingCart, class: ''},
  // { path: '/user/stats',         title: 'نتایج تست ها', icon: 'ni-bullet-list-67 text-red',    class: '' },
  {path: '/user/dashboard', title: 'فرم ها', icon: faListUl, class: 'text-red'},
  {path: '/user/files', title: 'نتایج تست', icon: faDownload, class: ''},
  {path: '/user/docs',  title: 'آپلود مدارک',        icon: faFile,    class: '' },
  {path: '/user/user', title: 'پروفایل', icon: faUser, class: ''},
  {path: '/logout', title: 'خروج', icon: faSignOutAlt, class: ''},
];

export const ADMINROUTES: RouteInfo[] = [
  {path: '/admin/dashboard', title: 'داشبورد', icon: faListUl, class: ''},
  {path: '/admin/results', title: 'نتایج فرم ها', icon: faNewspaper, class: ''},
  {path: '/admin/psycho-results', title: 'نتایج فرم متخصص', icon: faNewspaper, class: ''},
  {path: '/admin/orders', title: 'سفارش ها', icon: faShoppingCart, class: ''},
  {path: '/admin/tasks', title: 'تسک ها', icon: faTable, class: ''},
  {path: '/admin/appointments', title: 'رزرو ها', icon: faTable, class: ''},

  {path: '/admin/files', title: 'فایل ها', icon: faFile, class: ''},
  {path: '/admin/contacts', title: 'درخواست های تماس', icon: faPhoneAlt, class: ''},
  {path: '/admin/comments', title: 'پیام ها', icon: faComment, class: ''},
  {path: '/admin/users', title: 'کاربر ها', icon: faUsers, class: ''},
  {path: '/admin/more', title: 'دیگر', icon: faEllipsisH, class: ''},
  {path: '/logout', title: 'خروج', icon: faSignOutAlt, class: ''},
];

export const CRMROUTES: RouteInfo[] = [
  {path: '/crm/dashboard', title: 'داشبورد', icon: faListUl, class: ''},
  {path: '/crm/orders', title: 'سفارش ها', icon: faShoppingCart, class: ''},
  {path: '/crm/tasks', title: 'تسک ها', icon: faTable, class: ''},
  {path: '/crm/appointments', title: 'رزرو ها', icon: faTable, class: ''},
  {path: '/crm/edit-appointments', title: 'تایم خالی', icon: faTable, class: ''},
  {path: '/crm/results', title: 'نتایج فرم ها', icon: faNewspaper, class: ''},
  {path: '/crm/contacts', title: 'درخواست های تماس', icon: faPhoneAlt, class: ''},
  {path: '/crm/comments', title: 'پیام ها', icon: faComment, class: ''},
  {path: '/crm/users', title: 'کاربر ها', icon: faUsers, class: ''},
  {path: '/crm/inbox', title: 'پیامک ها', icon: faInbox, class: ''},
    {path: '/crm/files', title: 'فایل ها', icon: faFile, class: ''},

  {path: '/crm/message', title: 'ارسال پیامک', icon: faInbox, class: ''},
  {path: '/crm/group', title: 'ارسال پیامک گروهی', icon: faInbox, class: ''},

  // {path: '/crm/profile', title: 'پروفایل', icon: faUser, class: ''},
  {path: '/logout', title: 'خروج', icon: faSignOutAlt, class: ''},

];
export const EDITORROUTES: RouteInfo[] = [
  {path: '/editor/dashboard', title: 'داشبورد', icon: faListUl, class: ''},

  {path: '/editor/contacts', title: 'درخواست های تماس', icon: faPhoneAlt, class: ''},
  {path: '/editor/comments', title: 'پیام ها', icon: faComment, class: ''},
  {path: '/editor/inbox', title: 'پیامک ها', icon: faComment, class: ''},

  {path: '/editor/message', title: 'ارسال پیامک', icon: faSms, class: ''},
  {path: '/editor/profile', title: 'پروفایل', icon: faUser, class: ''},
  {path: '/logout', title: 'خروج', icon: faSignOutAlt, class: ''},
];


export const PYCHOLOGISTROUTES: RouteInfo[] = [
  {path: '/psychologist/dashboard', title: 'داشبورد', icon: faListUl, class: ''},
  {path: '/psychologist/users', title: 'کاربرها', icon: faUsers, class: ''},
  {path: '/psychologist/edit-appointments', title: 'تایم های ویزیت', icon: faCalendar, class: ''},
  {path: '/psychologist/appointments', title: 'رزرو ها', icon: faTable, class: ''},
  {path: '/psychologist/tasks', title: 'تسک ها', icon: faTable, class: ''},

  {path: '/psychologist/profile', title: 'پروفایل', icon: faUser, class: ''},
  {path: '/logout', title: 'خروج', icon: faSignOutAlt, class: ''},
];

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements AfterViewInit {

  public menuItems: any[];
  public isCollapsed = true;

  horizental = false;

  currentRoutes = [];

  hideMobileNav = false;

  constructor(private router: Router, public authenticationService: AuthenticationService, private cdRef:ChangeDetectorRef) {


  }

    ngAfterViewInit() {
    const currentUser = this.authenticationService.currentUserValue;
    if (currentUser.role === Role.User) {
      this.menuItems = ROUTES.filter(menuItem => menuItem);

    }

    if (currentUser.role === Role.Admin) {
      this.menuItems = ADMINROUTES.filter(menuItem => menuItem);
      this.horizental = true;
    }

    if (currentUser.role === Role.Editor) {
      this.menuItems = EDITORROUTES.filter(menuItem => menuItem);
      this.horizental = true;

    }

    if (currentUser.role === Role.Psychologist) {
      this.menuItems = PYCHOLOGISTROUTES.filter(menuItem => menuItem);
      this.horizental = true;

    }


    if (currentUser.role === Role.CRM) {
      this.menuItems = CRMROUTES.filter(menuItem => menuItem);
      this.horizental = true;

    }

    this.router.events.subscribe((event) => {
      this.isCollapsed = true;
    });


    this.currentRoutes = Array.from(this.menuItems, item => item.path);

    this.router.events.subscribe((event: NavigationEnd) => {
      if (this.currentRoutes.includes(event.url)) {
        this.hideMobileNav = false;
      } else {
        this.hideMobileNav = true;
      }

      const  index = this.menuItems.findIndex(item => item.path === event.url);
      if (index >= 0){
        this.align(index)
      }
    });
    this.align(0)

    this.cdRef.detectChanges();
  }


  align(index) {
    try {
       const items = document.querySelector('.list-wrap').children;
    // @ts-ignore
    for (let item of items) {
      item.classList.remove('active');
    }

    const width = window.innerWidth;


    setTimeout(() => {
      items[index].classList.add('active');
    }, 100);

    // move the wave
    const left = (index * (width / this.menuItems.length +1)) - 35;
    document.querySelector<HTMLElement>('#wave').style.left = left.toString();



    } catch (e){

    }

  }

}
